import snakeCase from 'lodash/snakeCase'
import { useMemo } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants'

export const useProductOptionsForQueryParams = ({
	selectedOptionsIdsValues = EMPTY_ARRAY,
	configurableOptions = EMPTY_ARRAY,
	bundleOptions = EMPTY_OBJECT,
} = {}) => {
	const productConfigurableOptionsForQueryParams = useMemo(
		() =>
			configurableOptions.reduce((acc, { attributeCode, attributeId, values }) => {
				const selectedOption = selectedOptionsIdsValues?.find(({ id }) => id === attributeId)
				let selectedOptionValueLabel
				if (selectedOption) {
					selectedOptionValueLabel = values.find(({ value }) => selectedOption.value === value)?.label
				}

				return {
					...acc,
					[attributeCode.toLowerCase()]: selectedOptionValueLabel?.toLowerCase?.(),
				}
			}, {}),
		[selectedOptionsIdsValues, configurableOptions]
	)

	const productBundleOptionsForQueryParams = useMemo(
		() =>
			bundleOptions?.items?.reduce((acc, { id, label, children }) => {
				const selectedOption = selectedOptionsIdsValues?.find(({ id: _id }) => _id === id)
				const selectedOptionValues = selectedOption?.selections
					?.map(({ id }) => {
						const selectedOptionValue = children.find(({ id: _id }) => _id === id)
						// do not return default values, or we will have a lot of unnecessary query params
						return !selectedOptionValue?.isDefault ? selectedOptionValue?.productSku : undefined
					})
					// remove undefined values
					?.filter((value) => value)

				return {
					...acc,
					[snakeCase(label?.toLowerCase?.())]: selectedOptionValues?.length ? selectedOptionValues : undefined,
				}
			}, {}),
		[selectedOptionsIdsValues, bundleOptions]
	)

	const productOptionsForQueryParams = useMemo(
		() => ({
			...productConfigurableOptionsForQueryParams,
			...productBundleOptionsForQueryParams,
		}),
		[productConfigurableOptionsForQueryParams, productBundleOptionsForQueryParams]
	)

	return productOptionsForQueryParams
}
